var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEth = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 67,
  height: 66,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#eth_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#260070",
  d: "M33.667 60.153c14.995 0 27.152-12.157 27.152-27.153S48.662 5.848 33.667 5.848 6.514 18.004 6.514 33s12.157 27.153 27.153 27.153"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000084",
  d: "M33.667 60.153c14.995 0 27.152-12.157 27.152-27.153S48.662 5.848 33.667 5.848 6.514 18.004 6.514 33s12.157 27.153 27.153 27.153"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4848FF",
  d: "M58.672 14.419H46.187v9.47h12.485z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4848FF",
  fillRule: "evenodd",
  d: "M8.661 23.888h20.27v34.489h9.47v-34.49h.015V14.42H8.661z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4848FF",
  d: "M33.667 7.792c13.9 0 25.207 11.308 25.207 25.208S47.566 58.208 33.666 58.208 8.46 46.9 8.46 33 19.767 7.792 33.667 7.792m0-7.792c-18.225 0-33 14.775-33 33s14.775 33 33 33c18.224 0 33-14.775 33-33s-14.776-33-33-33"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#eth_svg__b)",
  d: "m33.664 39.024-.213-.214V17.686l.213-.728 9.805 16.269zm0 1.856-.12.148v7.524l.12.352 9.812-13.818-9.812 5.792z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#eth_svg__c)",
  d: "M33.664 16.96v22.066l-8.899-5.26-.906-.535 9.805-16.269zm0 31.946v-8.023L23.86 35.09l9.805 13.818z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "eth_svg__b",
  x1: 23.221,
  x2: 47.828,
  y1: 37.338,
  y2: 26.954,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#606060"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "eth_svg__c",
  x1: 15.866,
  x2: 33.605,
  y1: 32.932,
  y2: 32.932,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#606060"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "eth_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.667 0h66v66h-66z"
})))));
export default SvgEth;